module.exports = __webpack_public_path__ + "img/image30.591b447a.png";